export default __webpack_public_path__ + "static/media/whitePaper.c9bfea4e.png";